import React, {FC, useCallback, useEffect, useMemo, useState, memo} from 'react';
import throttle from 'lodash/throttle';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
// @ts-ignore
import {ColorPicker as NativeColorPicker} from 'react-color-gradient-picker';
import 'react-color-gradient-picker/dist/index.css';
import {Color} from "@consts/types";
import usePrev from '@hooks/usePrev'
import {defaultColor, defaultGradient} from './const'
import {isGradient} from './utils'
import {ColorPickerWrap, PickerSelectWrap} from './styled'

export type ColorPickerProps = {
  id: string | number | undefined;
  color: Color | null;
  onChange: (color: Color) => void;
}
export type ColorPickerState = {
  color: Color;
  pikerIsGradient: boolean;
}

type NativeColorPickerProps = {
  gradient?: Color;
  color?: Color;
}

const ColorPicker:FC<ColorPickerProps>  = memo(({ id, color: payload, onChange }) => {
  const isColorGradient = !!payload && isGradient(payload);
  const [{ color, pikerIsGradient }, setState] = useState<ColorPickerState>({
    color: payload ?? defaultColor,
    pikerIsGradient: isColorGradient,
  })

  const prevId = usePrev(id);

  useEffect(() => {
    if (!payload) return;
    setState({
      color: payload ?? defaultColor,
      pikerIsGradient: isColorGradient,
    })
  }, [payload, isColorGradient, setState]);

  const onChangeType = useCallback((isGradient: boolean) => {
    const defaultPayload: Color = isGradient ? defaultGradient : defaultColor;
    onChange(defaultPayload);
    setState({
      pikerIsGradient: isGradient,
      color: defaultPayload,
    });
  }, [setState, onChange]);

  const onChangeColor = useCallback(throttle((color: Color) => {
    setState(state => ({ ...state, color }));
    onChange(color);
  }, 20), [setState, onChange]);

  const colorProps: any = useMemo(throttle(() => {
    const data: NativeColorPickerProps = {};
    if (!color) return data;

    const propertyKey: keyof NativeColorPickerProps = pikerIsGradient ? 'gradient' : "color";
    data[propertyKey] = { ...color };
    return data;
  }, 20), [color, pikerIsGradient])


  if (!!prevId && prevId !== id) return null;

  return (
    <>
      <PickerSelectWrap>
        <Select
          value={Number(pikerIsGradient)}
          fullWidth={true}
          onChange={(event) => onChangeType(!!event.target.value)}
        >
          <MenuItem value={0} >Fill</MenuItem>
          <MenuItem value={1} >Gradient</MenuItem>
        </Select>
      </PickerSelectWrap>
      <ColorPickerWrap>
        <NativeColorPicker
          // @ts-ignore
          onStartChange={onChangeColor}
          onChange={onChangeColor}
          onEndChange={onChangeColor}
          isGradient={pikerIsGradient}
          {...colorProps}
        />
      </ColorPickerWrap>
    </>
  )
})


export default ColorPicker